import * as React from 'react'
import { Button, Tab, Tabs, Container, Spinner } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'
import { useHistory } from "react-router-dom";
import * as _ from 'lodash'
import config from '../../../constants/config'
import * as actions from '../../../redux/actions'
import ClientTab from './ClientTab/ClientTab'
import ContactTab/*, { ContactObj, ContactT }*/ from './ContactTab/ContactTab'
import CrewTab from './CrewTab/CrewTab'
import DocumentsTab from './DocumentsTab/DocumentsTab'
import DocsTab from './DocsTab/DocsTab'

import FinancialTab from './FinancialTab/FinancialTab'
import WorkerFinancialTab from './WorkerFinancialTab/WorkerFinancialTab'
import JobTab from './JobTab/JobTab'
import DisputeTab from './DisputeTab/DisputeTab'


import { copyObject, isNumber, __pick } from '../../../utils'
import { SocketClient } from '../../../service/SocketClient';
import { companyObj, CompanyT, VariablesObj } from '../../../types/Company'


import { JobWorkerObj, JobWorkerT } from '../../../types/JobWorker'
import { JobApplyFilters } from './JobApplyFilters'
import { ClientT } from '../../../types/Users';
import { currentCanViewFinancials, currentUserCompanyId, currentUserIsAdmin, currentUserIsClient, currentUserIsExternalAdmin, currentUserIsManager, currentUserIsWorker, getCurrentUserId } from '../../../utils/currentUser'

import moment from 'moment'
import ButtonLoading from '../../../components/ButtonLoading/ButtonLoading';
import { IAppState } from '../../../redux/reducers';
import { AuthStateT } from '../../../redux/reducers/authReducer';
import { RentTruckTab } from './RentTruckTab/RentTruckTab';
import { JobT, LocationT } from '../../../types/Job';
import { DocumentsObj, FinancialObj, JobObj } from './InitObjectJob';
import PaymentsTab from './PaymentsTab/PaymentsTab';
import { Box, Typography, Tabs as MaterialTabs, Tab as MaterialTab } from '@mui/material';
import { useImmer, useImmerReducer } from 'use-immer'
import { AxiosInstance } from '../../../utils/RequestMethods';
import { resolveJobTypeFromLocations } from './resolveJobTypeFromLocations';
import instanceSocketClient, { getInstanceSocketClient } from '../../../service/InstanceSocketClient';
import { socketEvents } from '../../../service/socketEvents';
import { getPinJobA } from '../PinMarkerJobs';
import { extractImpliedLineDate, getMarkers } from './JobUtils';


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}








interface CrewT { }

const initialCoords = {
  latitude: Number(config.coords.lat),
  longitude: Number(config.coords.long)
}



export interface ClosedInT {
  communicationId: number
  time: number
}

interface JobProps { }

interface LocationsT { }



export enum JobMode {
  New = 'new',
  Edit = 'edit',
  Dispute = 'dispute',
}


/**
 *
 * @param permission
 * @param job
 * @param workerId
 */
export const workerHasPermission = (permission: string, job: JobT, workerId: number): boolean => {
  const crew = job.crew ? job.crew : []
  const workerCrew = crew.find((x) => x.id == workerId)
  if (workerCrew) {
    const permissions = workerCrew.permissions ? workerCrew.permissions : []
    return permissions.includes(permission)
  }
  return false
}

/**
 *
 * @param job
 * @param workerId
 */
export const workerIsExistsInCrew = (job: JobT, workerId): boolean => {
  const crew = job.crew && _.isArray(job.crew) ? job.crew : []
  const find = crew.find((x) => x.id == workerId)

  return find ? true : false
}


/**
 *
 * @param value
 */
export const parseFloatTotal = (value: number | string): string => {
  if (!value) {
    return "0.00";
  }
  return parseFloat(`${value}`).toFixed(2)
}


type JobTabsT = 'job' | 'client' | 'crew' | 'contact' | 'documents' | 'financial' | 'workerFinancial' | 'payments' | 'rentTruck'  | 'dispute'

const TabsShowButtonSave = ['job', 'crew', 'documents', 'financial', 'payments']

const JOB_TABS_STORAGE_KEY = 'job_tabs_order'
const DEFAULT_TABS_ORDER: JobTabsT[] = [
  'job', 'client', 'crew', 'contact', 'documents',
  'financial', 'workerFinancial', 'payments', 'rentTruck', 'dispute',
]

const loadTabsOrder = (): JobTabsT[] => {
  try {
    const saved = localStorage.getItem(JOB_TABS_STORAGE_KEY)
    if (!saved) return DEFAULT_TABS_ORDER
    const savedKeys: JobTabsT[] = JSON.parse(saved)
    const merged = savedKeys.filter(k => DEFAULT_TABS_ORDER.includes(k))
    const newTabs = DEFAULT_TABS_ORDER.filter(k => !merged.includes(k))
    return [...merged, ...newTabs]
  } catch {
    return DEFAULT_TABS_ORDER
  }
}

const saveTabsOrder = (order: JobTabsT[]) => {
  localStorage.setItem(JOB_TABS_STORAGE_KEY, JSON.stringify(order))
}


const Job: React.FunctionComponent<JobProps> = ({ }): JSX.Element => {
  let auth: AuthStateT = useSelector((state: IAppState) => state.auth)
  const [company, setCompany] = React.useState(copyObject(companyObj))
  const [jobOrigin, setJobOrigin] = React.useState(copyObject(JobObj))
  const [job, setJob] = React.useState<JobT>(copyObject(JobObj))
  let [markers, setMarkers] = React.useState([])
  let [coords, setCoords] = React.useState(initialCoords)
  const [isReady, setIsReady] = React.useState(false)
  const [isReadyAll, setIsReadyAll] = React.useState(false)
  const [isRefreshJob, setIsRefreshJob] = React.useState(true)
  const [compnayIsReady, setCompnayIsReady] = React.useState(false)
  const [jobMode, setJobMode] = React.useState(JobMode.New)
  const [dirtyJob, setDirtyJob] = React.useState({})
  const [filtersJob, setFiltersJob] = React.useState([]);
  const match = useRouteMatch()
  const history = useHistory()
  const currentUserId = getCurrentUserId()
  const roles = auth && auth.userData && auth.userData.roles ? auth.userData.roles : []
  const btnSaveRef = React.useRef(null)
  const [tabsOrder, setTabsOrder] = React.useState<JobTabsT[]>(loadTabsOrder)
  const [activeTab, setActiveTab] = React.useState<JobTabsT>(() => loadTabsOrder()[0] ?? "job");
  const dragTabIndex = React.useRef<number | null>(null)
  const [tabDragOver, setTabDragOver] = React.useState<number | null>(null)
  const [lineItemDate, setLineItemDate] = React.useState('')
  const [lineItemDateDirty, setLineItemDateDirty] = React.useState(false)

  const companyId = currentUserCompanyId()
  const [showAlertDelete, setShowAlertDelete] = React.useState(false);
  const [showRentTruck, setShowRentTruck] = React.useState(false);
  const [fetchIsError, setFetchIsError] = React.useState(false);
  const formRef = React.useRef(null)
  const [result, setResult] = React.useState({
    processing: false,
    msg: '',
    isSuccess: false,
    showMsg: false,
  });

  const isAdmin = currentUserIsAdmin()
  const isExternalAdmin=currentUserIsExternalAdmin()
  const isManager = currentUserIsManager()

  const isClient = currentUserIsClient()
  const isWorker = currentUserIsWorker()
  const canViewFinancials = currentCanViewFinancials()

  const [useTruck, setUseTruck] = React.useState<boolean | null>(true);

  const jobIdRef = React.useRef(null);
  const socketRef = React.useRef(null);
  const [counterRefresh, setCounterRefresh] = React.useState(0);
  // const job = job

  /**
     *
     * @return JobT
     */
  const saveJob = async (): Promise<JobT> => {

    let params = null
    // console.log("saveJob", job)
    console.log("saveJob->dirtyJob", dirtyJob)
    let url = `${config.url.wpJson}/wp/v2/jobs`;
    if (jobMode == JobMode.Edit) {
      params = copyObject(dirtyJob)
      url = `${config.url.wpJson}/wp/v2/jobs/${job.id}`
      delete params.addedBy;
    } else {
      params = copyObject(job)
      console.log('JOBXXXXXXX', params)
      // we not need send this info when create new job
      delete params.id;
      delete params.addedBy;
      if (isClient) {
        let jobType = await resolveJobTypeFromLocations(params.locations, useTruck, params.companyInfo.variables)
        params.jobType = jobType
      }
      params = JobApplyFilters(params)
    }

    return await AxiosInstance.post(url, params).then((res) => {
      if (res && (res.status || res.status == 200 || res.status == 201)) {
        return res.data;
      } else {
        return null
      }
    }).catch(err => {console.log(err)})
  }




  React.useEffect(() => {
    console.log("instanceSocketClient", instanceSocketClient)
    console.log('JOBJOBX ', job)
    initJob()

    return () => {
      if (jobIdRef && jobIdRef.current) {
        instanceSocketClient.off(`${socketEvents.updateCommunications}-${jobIdRef.current}`);
        instanceSocketClient.off(`${socketEvents.updateJobs}-${jobIdRef.current}`);
        instanceSocketClient.emit(socketEvents.leaveJob, jobIdRef.current)
        console.log("leave-job")
      }
    }
  }, [])


  React.useEffect((): void => {
    if (auth?.userData?.addressDetails) {
      setCoords({
        latitude: Number(auth?.userData?.addressDetails.latitude),
        longitude: Number(auth?.userData?.addressDetails.longitude)
      })
    }

  }, [auth?.userData])


  React.useEffect((): void => {
    jobTypesByLocations()
  }, [job.locations])

  /*React.useEffect(() => {
      setLineItemDate('yoyoyo')
      if(_.isArray(job.locations) && job.locations.length > 0 &&
          _.isArray(job.locations[0].activities))
      console.log('JOBJOBX', job)
  }, [lineItemDate])*/


  const getCompany = async (companyId: number): Promise<CompanyT | null> => {
    if (companyId != undefined && companyId != null) {
      return AxiosInstance.get(`${config.url.companies}/${companyId}`).then((res) => {
        if (res && res.data) {
          let resCompany = copyObject({ ...companyObj, ...res.data })
          if (resCompany.variables) {
            resCompany.variables = copyObject({ ...VariablesObj, ...resCompany.variables })
          }
          return resCompany
        }
      }).catch((error) => {
        return null
      })
    }

    return null
  }


  const initJob = async (): Promise<void> => {
    let j = null;
    try {
      if (match && match.params && match.params.job_id) {
        const resCompany = await getCompany(companyId)
        if (resCompany) {
          setCompany(resCompany)
        }

        setCompnayIsReady(true)
        console.log("resCompany", resCompany)
        console.log("match.params", match.params)

        // initGetCompany(match.params.jo)
        if (isNumber(match.params.job_id)) {
          getJobById(match.params.job_id).then((j) => {
            console.log("JobApplyFilters->edit", j)
            if (j) {
              setJobMode(JobMode.Edit)

              refreshJob(j)
              socketConnect(j)
              setIsReady(true)

              // setLineItemDate(moment(j.locations[0].activities[0].activityDate).format('MM/DD/YYYY'))
            }
          }).catch((error) => {
            setFetchIsError(true)
          })
        } else if (match.params.job_id == 'add-job') {
          j = copyObject(job)
          j.addedBy = auth.userData.id
          if (roles.includes('client')) {
            j.client = __pick(auth.userData, Object.keys(job.client))
          }
          if (resCompany) {
            j.companyInfo = copyObject(resCompany)
          }
          console.log("iniJob", j)
          refreshJob(j)
          setJobMode(JobMode.New)
          setIsReady(true)
        }
      }
    } catch (error) {
      console.log("error", error)
    }
  }


  // const updateAllFieldsJob = (data) => {
  //     setJob((dreft) => {
  //         Object.keys(data).map((key, index) => {
  //             if (_.has(dreft, key)) {
  //                 dreft[key] = data[key]
  //             }
  //         })
  //     })
  // }


  const initGetCompany = async (companyId) => {
    const resCompany = await getCompany(companyId)
    if (resCompany) {
      setCompany(resCompany)
    }
    setCompnayIsReady(true)
  }
  // const getInitJob = (): JobT => {
  //     let cloneInitJob = copyObject(JobObj)


  //     return cloneInitJob
  // }

  const socketConnect = (job: JobT) => {
    jobIdRef.current = job.id
    const socket = getInstanceSocketClient()
    socketRef.current = socket
    socket.emit("join-job", job.id)

    /**
     * receive signal if job is update
     * then request get job
    */
    const event = `${socketEvents.updateJobs}-${job.id}`
    console.log("event", event)
    socket.on(event, (args) => {
      console.log("socket->update-jobs->jobid", args)
      socket.emit("feedback-update-jobs", { path: "job", jobId: job.id, platform: config.platform })
      getJobById(job.id).then((j) => {
        if (j) {
          // should be init dirtyJob when come data from socket
          setDirtyJob({})
          let jobClone = JobApplyFilters(j)
          refreshJob(jobClone)
        }
      })
    })
  }

  /**
   * fetch getJobById
   * @param id
   */
  const getJobById = async (id: number): Promise<JobT | void> => {
    const url = `${config.url.jobs}/${id}`
    return AxiosInstance.get(url).then((res) => {
      if (res && res.data) {
        let j = copyObject({ ...JobObj, ...res.data })
        return j;
      }
    }).catch((error) => {
      throw error;
    })
  }


  const jobTypesByLocations = (): Array<string> => {
    if (!job || !job.locations || !_.isArray(job.locations)) {
      return []
    }
    let nonemptyLocations: Array<LocationT> = job.locations.filter((location: LocationT) => {
      return location.addressCountry != ''
    })
    if (nonemptyLocations.length == 0) return ['moving_labor', 'intrastate_local', 'intrastate_long', 'interstate', 'international', 'junk_removal']
    for (let i = 1; i < nonemptyLocations.length; ++i) {
      if (nonemptyLocations[i].addressCountry != nonemptyLocations[i - 1].addressCountry) {
        // console.log('LOCCS: international')
        return ['international']
      }
    }
    nonemptyLocations = job.locations.filter((location: LocationT) => {
      return location.addressState != ''
    })
    for (let i = 1; i < nonemptyLocations.length; ++i) {
      if (nonemptyLocations[i].addressState != nonemptyLocations[i - 1].addressState) {
        // console.log('LOCCS: interstate')
        return ['moving_labor', 'interstate']
      }
    }
    //console.log('LOCCS: none')
    return ['moving_labor', 'intrastate_local', 'intrastate_long']
  }

  const clickedSaveJob = async () : Promise<string> => {
    setResult((draft) => {
      draft.processing = true
      return draft
    })
    try {
      let data = await saveJob()
      if (data) {
        let msg = 'Job saved.'
        if (jobMode == JobMode.New) {

          setTimeout(() => {
            history.push(`${data.id}`)
            // setJobMode(JobMode.Edit)
          }, 1);

          // Delay until getting ready children components
          setTimeout(() => {
            refreshJob(copyObject(data))
            socketConnect(data)
            setJobMode(JobMode.Edit)
            // setJobMode(JobMode.Edit)
          }, 100);

          return msg;
        } else {
          refreshJob(copyObject(data))
          return msg;
        }

      }
      throw new Error("Job save failed.");

    } catch (error) {

      throw error;
    }
  }



  /**
   *
   * @param params
   * @returns
   */
  const customSaveJob = async (params: JobT | null): Promise<JobT> => {
    if (params != null) {
      params = { ...dirtyJob, ...params }
      setDirtyJob(params)
    }

    let url = `${config.url.wpJson}/wp/v2/jobs`
    if (job.id != null) {
      url = `${config.url.wpJson}/wp/v2/jobs/${job.id}`
    }

    console.log('params', params)
    return AxiosInstance.post(url, params).then((res) => {
      if (res && (res.status || res.status == 200 || res.status == 201)) {
        return res.data;
      } else {
        return null;
      }
    })
  }


  /**
   * use this function  when receive data from back-end
   * @param newJob
   */
  const refreshJob = (newJob: JobT, rest = false): void => {
    console.log("newJob", newJob)
    newJob = rest ? newJob : { ...job, ...newJob }
    let j = newJob
    try {
      j = JobApplyFilters(copyObject(newJob))
    } catch (error) {
      console.log("error", error)
    }

    console.log("ewwerwerw", newJob)
    console.log("refreshJob", j)

    setJob(copyObject(j))
    setJobOrigin(copyObject(j))

    // setIsRefreshJob(false);
    setTimeout(() => {
      setIsReadyAll(true)
    }, 500);
  }


  const reloadJob = async (): Promise<JobT> => {

    if (!_.isNil(job.id)) {
      const j = await getJobById(job.id)

      if (j) {
        refreshJob(j)
        return j
      }
    }
    throw new Error("Job id not found.")
  }

  const goTojobs = (): void => {
    history.push({
      pathname: `/jobs`
    })
  }
  /**
   *
   * @returns
   */
  const deleteJob = async (): Promise<string> => {
    let url = `${config.url.wpJson}/wp/v2/jobs/${job.id}`
    try {

      let res = await AxiosInstance.delete(url)
      if (res && res.data) {
        setTimeout(() => {
          goTojobs()
        }, 1000);
        return "Job deleted."
      }
      throw "job deletion failed.";
    } catch (error) {
      throw error;

    }
  }


  // Key Params
  //      @addedBy
  //      @cargo
  //      @client
  //      @crew
  //      @documents
  //      @financials
  //      @jobSource
  //      @jobStatus
  //      @jobType
  //      @locations
  //      @notes
  //      @payments
  const updateJob = (key: string, value: any): void => {
    let jobClone = copyObject(job)
    jobClone[key] = value
    console.log('jobClone->key: ', key)
    console.log('jobClone: ', jobClone)
    // console.log("jobClone->json",JSON.stringify(jobClone).length)
    let cloneDirtyJob = copyObject(dirtyJob)

    let newJob = JobApplyFilters(jobClone)

    // let newJob =jobClone
    setJob(copyObject(newJob))
    setMarkers(getMarkers(newJob))
    cloneDirtyJob[key] = value
    if (isManager) {
      setDirtyJob(newJob)
    } else {
      setDirtyJob(cloneDirtyJob)
    }
    console.log('Job Object is now: ', newJob)

  }
  // console.log("dirtyJob", dirtyJob)


  const propagateDate = (activityDate: string) => {
    console.log('yoyoHi', activityDate)
    setLineItemDate(activityDate)
    //alert(activityDate)
  }

  const renderTabsBootstrap = () => {
    // Define all tabs with their visibility condition and content
    const allTabDefs: { key: JobTabsT; label: string; visible: boolean; content: JSX.Element }[] = [
      {
        key: 'rentTruck', label: 'Rent Truck', visible: showRentTruck,
        content: <RentTruckTab />,
      },
      {
        key: 'job', label: 'Job', visible: true,
        content: (
          <JobTab
            tabIsActive={activeTab === 'job'}
            jobMode={jobMode}
            coords={coords}
            job={job}
            markers={getMarkers(job)}
            propagateDate={propagateDate}
            strictJobTypes={jobTypesByLocations()}
            updateJob={updateJob}
            showRentTruck={() => { setShowRentTruck(true); setActiveTab('rentTruck') }}
            useTruck={useTruck}
            onChangeUseTruck={(value) => setUseTruck(value as boolean)}
          />
        ),
      },
      {
        key: 'client', label: 'Client',
        visible: isManager || (isWorker && workerHasPermission('sales', job, currentUserId)),
        content: (
          <ClientTab
            tabIsActive={activeTab === 'client'}
            jobMode={jobMode}
            client={job.client}
            job={job}
            customSaveJob={customSaveJob}
            updateJob={updateJob} />
        ),
      },
      {
        key: 'contact', label: 'Contact',
        visible: (isManager || (isWorker && workerHasPermission('contact', job, currentUserId))) && jobMode === JobMode.Edit,
        content: (
          <ContactTab
            tabIsActive={activeTab === 'contact'}
            job={job}
            jobMode={jobMode}
            socket={socketRef && socketRef.current} />
        ),
      },
      {
        key: 'crew', label: 'Crew',
        visible: isManager || (roles.includes('client') && jobMode === 'edit'),
        content: (
          <CrewTab
            tabIsActive={activeTab === 'crew'}
            company={company}
            job={job}
            jobMode={jobMode}
            updateJob={updateJob} />
        ),
      },
      {
        key: 'financial', label: 'Financial',
        visible: ((isAdmin || isExternalAdmin) || (isManager && canViewFinancials)),
        content: (
          <FinancialTab
            tabIsActive={activeTab === 'financial'}
            jobMode={jobMode}
            job={job}
            lineItemDate={lineItemDate}
            refreshJob={refreshJob}
            saveJob={saveJob}
            updateJob={updateJob} />
        ),
      },
      {
        key: 'workerFinancial', label: 'Financial',
        visible: isWorker && workerIsExistsInCrew(job, currentUserId),
        content: <WorkerFinancialTab job={job} />,
      },
      {
        key: 'documents', label: 'Documents',
        visible: isManager
          || (isClient && jobMode === JobMode.Edit && (job.companyInfo.showDocuments === true || job.jobType === 'interstate'))
          || (isWorker && workerHasPermission('documents', job, currentUserId) && jobMode === JobMode.Edit),
        content: (
          <DocumentsTab
            tabIsActive={activeTab === 'documents'}
            company={company}
            job={job}
            jobOrigin={jobOrigin}
            jobMode={jobMode}
            saveJob={saveJob}
            refreshJob={refreshJob}
            updateJob={updateJob} />
        ),
      },
      // {
      //   key: 'docs', label: 'Docs',
      //   visible: isManager && !!JobMode.Edit,
      //   content: (
      //     <DocsTab
      //       company={company}
      //       job={job}
      //       tabIsActive={activeTab === 'docs'} />
      //   ),
      // },
      {
        key: 'payments', label: 'Payments',
        visible: isClient && jobMode === JobMode.Edit,
        content: (
          <PaymentsTab
            tabIsActive={activeTab === 'payments'}
            job={job}
            company={company}
            jobMode={jobMode}
            saveJob={saveJob}
            refreshJob={refreshJob}
            reloadJob={reloadJob}
            updateJob={updateJob} />
        ),
      },
      {
        key: 'dispute', label: 'Dispute',
        visible: isManager && job.fkDispute !== '',
        content: <DisputeTab job={job} />,
      },
    ]

    // Sort tabs by tabsOrder and filter to visible only
    const visibleTabs = tabsOrder
      .map(k => allTabDefs.find(t => t.key === k))
      .filter(t => t && t.visible) as typeof allTabDefs

    // If the active tab is not visible, fall back to the first visible tab
    const activeVisible = visibleTabs.find(t => t.key === activeTab)
    const currentActiveKey = activeVisible ? activeTab : (visibleTabs[0]?.key ?? 'job')
    const tabContentStyle = currentActiveKey === 'contact'
      ? {
        padding: '12px 0',
        height: 'calc(100vh - 150px)',
        minHeight: 420,
        overflow: 'hidden' as const,
      }
      : { padding: '12px 0' }

    const handleTabDrop = (dropIndex: number) => {
      const from = dragTabIndex.current
      if (from === null || from === dropIndex) {
        dragTabIndex.current = null
        setTabDragOver(null)
        return
      }
      // Reorder visible tabs only
      const visibleKeys = visibleTabs.map(t => t.key)
      const [moved] = visibleKeys.splice(from, 1)
      visibleKeys.splice(dropIndex, 0, moved)
      // Build new tabsOrder: visible tabs in new order + hidden tabs appended at the end
      const hiddenKeys = tabsOrder.filter(k => !visibleKeys.includes(k))
      const newOrder: JobTabsT[] = [...visibleKeys, ...hiddenKeys]
      setTabsOrder(newOrder)
      saveTabsOrder(newOrder)
      // Activate the first visible tab after reordering
      setActiveTab(visibleKeys[0])
      dragTabIndex.current = null
      setTabDragOver(null)
    }

    return (
      <div>
        {/* Tab Headers */}
        <div style={{ display: 'flex', flexWrap: 'wrap', borderBottom: '2px solid #dee2e6', marginBottom: 0, gap: 2 }}>
          {visibleTabs.map((tab, index) => {
            const isActive = tab.key === currentActiveKey
            const isDragOver = tabDragOver === index
            return (
              <div
                key={tab.key}
                draggable
                onDragStart={(e) => {
                  dragTabIndex.current = index
                  e.dataTransfer.effectAllowed = 'move'
                }}
                onDragOver={(e) => { e.preventDefault(); setTabDragOver(index) }}
                onDrop={() => handleTabDrop(index)}
                onDragEnd={() => { dragTabIndex.current = null; setTabDragOver(null) }}
                onClick={() => setActiveTab(tab.key)}
                style={{
                  padding: '8px 16px',
                  cursor: 'pointer',
                  userSelect: 'none',
                  borderRadius: '4px 4px 0 0',
                  border: isActive ? '1px solid #dee2e6' : '1px solid transparent',
                  borderBottom: isActive ? '2px solid #fff' : 'none',
                  marginBottom: isActive ? -2 : 0,
                  background: isActive ? '#fff' : 'transparent',
                  fontWeight: isActive ? 600 : 400,
                  color: isActive ? '#495057' : '#6c757d',
                  fontSize: 14,
                  outline: isDragOver ? '2px dashed #0d6efd' : 'none',
                  transition: 'background 0.1s',
                }}
              >
                <span style={{ marginRight: 4, color: '#bbb', fontSize: 12 }}>⠿</span>
                {tab.label}
              </div>
            )
          })}
          {/* Reset tab order button */}
          <button
            onClick={() => {
              localStorage.removeItem(JOB_TABS_STORAGE_KEY)
              setTabsOrder(DEFAULT_TABS_ORDER)
              setActiveTab(DEFAULT_TABS_ORDER[0])
            }}
            title="Reset tab order"
            style={{
              marginLeft: 'auto',
              alignSelf: 'center',
              fontSize: 11,
              padding: '3px 10px',
              borderRadius: 12,
              border: '1px solid #ced4da',
              background: 'transparent',
              cursor: 'pointer',
              color: '#888',
            }}
          >
            ↺ Reset
          </button>
        </div>

        {/* Tab Content */}
        <div style={tabContentStyle}>
          {visibleTabs.find(t => t.key === currentActiveKey)?.content}
        </div>
      </div>
    )
  }


  if (fetchIsError) {
    return (
      <Container className="mt-5 text-center">
        <div className="alert alert-danger d-flex flex-column">
          <span>Job not found.</span>
          <Button onClick={goTojobs}>Go to jobs</Button>
        </div>
      </Container>
    )
  }

  if (!isReady || !compnayIsReady || !job) {
    return (
      <Container className="mt-5 ">
        <div className="d-flex flex-column align-items-center justify-content-center">
          <span>Loading...</span>
          <Spinner animation="border" variant="success" />
        </div>
      </Container>
    )
  }
  return (
    <div className='mb-5' style={{ padding: '0 8px' }}>

      {renderTabsBootstrap()}
      {((isManager || (isClient && job.jobStatus != "completed") || (isWorker && workerHasPermission("sales", job, currentUserId))) && TabsShowButtonSave.includes(activeTab)) &&
        <div className="mt-3 d-flex flex-column">
          {(activeTab == "job" && showAlertDelete && jobMode == JobMode.Edit) && <div className="alert alert-danger d-flex flex-column">
            <span>Are you sure you want to delete this job?</span>
            <div className="d-flex flex-row">
              <Button variant="light" onClick={() => { setShowAlertDelete(false) }}>Cancel</Button>
              <ButtonLoading type="button" onClickFetching={deleteJob} className="btn-outline-danger">Delete Job</ButtonLoading>
            </div>
          </div>}

          {(((isClient && job?.jobStatus != 'completed') || isManager) && activeTab != "documents" && activeTab != 'payments') && <div className="d-flex">
            <ButtonLoading onClickFetching={clickedSaveJob} type="button" className="btn-success">
              {(isClient && activeTab == "crew") ? "Save Crew" : "Save Job"}
            </ButtonLoading>
            {(activeTab == "job" && jobMode == JobMode.Edit) && (isManager || (isClient && job.jobStatus == "inquiring")) &&
              <Button variant="outline-danger" disabled={showAlertDelete} onClick={() => { setShowAlertDelete(true) }}>Delete Job</Button>}
          </div>}
        </div>}

      <br /><br /><br />
    </div>
  )
}


export default Job
